const axios = require('axios');
import {errorHandler} from "./common";

export function userSignIn(email, password) {
  return new Promise(function (resolve, reject) {
    let url = process.env.ROOT_API + 'user/signIn?email=' + email + '&password=' + password;
    axios.post(url)
      .then(function (response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function (err) {
        reject(err);
      })
  })
}

export function addUser(user) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'user/signUp', JSON.stringify(user), {
      headers:{
        "Content-Type": "application/json",
        // "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Add USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function getUserByToken() {
  return new Promise(function(resolve, reject) {
    console.log("getUserBytToken")
    axios.get(process.env.ROOT_API + 'user/me', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
        //reject()
      });
  })
}


export function getUserList(type) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/users?type=' + type, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
    .catch(error=>{
      console.log("error to update");
      console.log(error.response);
      errorHandler(error);
      reject(error);
      //reject()
    });
  })
}
export function getStaffList(type) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/staffs?type=' + type, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
        //reject()
      });
  })
}
export function getUser(id) {
  return new Promise(function (resolve, reject) {
    axios.get(process.env.ROOT_API + 'user/' + id, {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function deleteUser(id) {
  return new Promise(function (resolve, reject) {
    axios.delete(process.env.ROOT_API + 'user/' + id, {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
/**
 * Create users at one go
 * @param user
 * @returns {Promise<unknown>}
 */
export function createUsers(users) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'users', JSON.stringify(users), {
      headers:{
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

/**
 * Create users at one go
 * @param user
 * @returns {Promise<unknown>}
 */
export function updateUser(user) {
  return new Promise(function (resolve, reject) {
    axios.put(process.env.ROOT_API + 'user', JSON.stringify(user), {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}


export function sendEmail(content) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'sendEmail', JSON.stringify(content), {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function createNewUser() {
  let newUser = {
    id:0,
    name:'',
    email:'',
    password:'',
    password2:'',
    merchantId:0,
    role:'staff',
    type:'ROLE_STAFF',
  }

  return newUser;
}



// WEBPACK FOOTER //
// ./src/api/user.js